<script lang="ts">
	import { navigate } from "svelte-routing";
	import logo from "../assets/img/Logo.png";
	export let clearMode = false;
	export let useLogo = true;
	export let method = "POST";
	export let action = "";

</script>

{#if useLogo}
	<img id="logo" src={logo} alt="Logo" on:click={() => navigate('/')} />
{/if}
<form on:submit class:clear={clearMode} method={method} action={action}>
	<slot />
</form>

<style lang="scss">
	@import "../variables.scss";

	form {
		max-width: 460px;
		width: 100%;
		box-sizing: border-box;
		padding: 30px;
		border-radius: 10px;

		background-color: $defaultFormColor;

		&.clear {
			background-color: transparent;
		}
	}
	#logo {
		margin-bottom: 30px;
		width: 148px;
		height: 67px;

		&:hover {
			cursor: pointer;
		}
	}

</style>
